import angular from 'angular';
import _ from 'lodash';
import $ from 'jquery';
import * as actions from '../../store/actions';

angular.module('webTools').directive('wtGrid', ['$rootScope', '$compile', '$location', '$timeout', '$document', 'Auth', 'Columns', 'GridTools', '$ngRedux', '$window',
  function ($rootScope, $compile, $location, $timeout, $document, Auth, Columns, GridTools, $ngRedux, $window) {
        return {
            restrict: 'E',
            replace: true,
            transclude: false,
            template: '<div></div>',
            scope: {
                localOptions: '=wtOptions',
                gridDataSource: '=wtDataSource',
                gridColumns: '&wtColumns',
                workingFolder: '=wtWorkingFolder',
                menuOptions: '=wtMenuOptions',
                gridName: '=wtGridName',
                kendo: '=kendoScope',
                onColumnReset: '=',
                showColumnReset: '='
            },
            controller: ['$scope', '$routeParams', 'Columns', function($scope, $routeParams, Columns) {

                $scope.data = $scope.data || {};

                if (localStorage.getItem('pageSize')) {
                    $rootScope.pageSize = localStorage.getItem('pageSize');
                };

                var enableCheckbox = function() {
                    this.element.find(".k-columns-item :checkbox").prop("disabled", false);
                }

              $scope.getCurrentPage = function () {
                if (!$scope.localOptions.responsive) {
                  return 1;
                } else {
                  return $routeParams.page || 1;
                }  
              }

                $scope.kendo.selectGridItem = function (objectId) {

                    var wtObject = _.find($scope.kendo[$scope.gridName]._data, function (ds) { return ds.ID === objectId; })

                    var gridItem = angular.element('tr[data-uid="' + wtObject.uid + '"]');

                    gridItem.click();

                    $(".k-grid-content").animate({
                        scrollTop: gridItem.position().top
                    }, 'slow');
              }

              const store = $ngRedux.getState();

              $scope.localOptions.pageable.pageSizes = store.app.pageSizes;

              $scope.localOptions.dataBound = function (e) {

                // clear any previous selection if we don't allow multi-select
                if (!$scope.localOptions.allowMultiselect && $scope.selectedItems.length > 0) {
                  $scope.selectedItems = [];
                  $scope.updateItems();
                }

                var visibleRows = $('.k-grid-content').find('tr');

                let masterCheckboxRef = this.element.find('.master-checkbox');
                
                if (masterCheckboxRef.length > 0 && visibleRows.find('.checkbox').length > 0 && $scope.localOptions.allowMultiselect) {

                  masterCheckboxRef.unbind('click').click(function (e) {
                    if ($(this).hasClass('checked')) {
                      $scope.uncheckAll();
                    } else {
                      $scope.checkAll();
                    }
                    $(this).toggleClass('checked');
                    $scope.$apply();
                  })

                  $scope.$watch(function () { return $scope.allSelected(); },
                    function (allSelected) {
                      allSelected ? masterCheckboxRef.addClass('checked') : masterCheckboxRef.removeClass('checked');
                    }
                  )

                  masterCheckboxRef.show();

                } else {
                  masterCheckboxRef.hide();
                }

                if (visibleRows.length === 0) { $scope.$emit('gridLoaded'); $scope.kendo.resizeGrid(); return false; }

                if ($scope.kendo[$scope.gridName]) {
                  if ($rootScope.pageSize !== $scope.kendo[$scope.gridName].dataSource.pageSize()) {
                    $scope.$apply(function () {
                      localStorage.setItem('pageSize', $scope.kendo[$scope.gridName].dataSource.pageSize().toString());
                      $rootScope.pageSize = $scope.kendo[$scope.gridName].dataSource.pageSize();
                    });
                  }
                }

                var selectedClass = 'k-state-selected';
                var lastSelected = 'last-selected';
                var itemSelected = false;

                if ($scope.localOptions.allowSelectFolders === true) {
                  angular.element(visibleRows[0]).addClass('last-selected');
                } else {
                  visibleRows.each(function () {
                    if (!$scope.isFolder(this)) {
                      angular.element(this).addClass('last-selected');
                      return false;
                    }
                  })
                }

                if ($scope.selectedItems.length > 0) {

                  visibleRows.each(function () {
                    var uid = angular.element(this).attr('data-uid');
                    var wtObject = _.find($scope.kendo[$scope.gridName]._data, function (ds) { return ds.uid === uid; });

                    if (_.find($scope.selectedItems, { ID: wtObject.ID, Version: wtObject.VersionID, VersionID: wtObject.VersionID })) {
                      $(this).addClass('k-state-selected').find('.checkbox').addClass('checked');
                    }

                  });
                }

                if ($scope.localOptions.allowRowSelect) {
                  visibleRows.bind('click', function (e) {
                    var element = angular.element(this);

                    if ($scope.isFolder(element) && $scope.localOptions.allowSelectFolders !== true) { return true; }

                    if ((e.ctrlKey || e.metaKey) && $scope.localOptions.allowMultiselect) {
                      if (element.hasClass(selectedClass)) {
                        element.removeClass(selectedClass).find('.checkbox').removeClass('checked');
                      } else {
                        element.parent().children().removeClass(lastSelected);
                        element.addClass(selectedClass + ' ' + lastSelected).find('.checkbox').addClass('checked');
                        itemSelected = true;
                      }
                    } else if (e.shiftKey && $scope.localOptions.allowMultiselect) {

                      element.parent().children().removeClass(selectedClass);
                      itemSelected = true;

                      if (element.prevAll('.last-selected').length === 1) {

                        element.parent().find('.last-selected').nextUntil(element).addBack().add(element).addClass(selectedClass);

                      } else if (element.nextAll('.last-selected').length === 1) {

                        element.nextUntil(element.parent().find('.last-selected')).addBack().add(element.parent().find('.last-selected')).addClass(selectedClass);

                      }
                    } else {

                      let shouldSelect = $scope.selectedItems.length > 0 && $scope.localOptions.allowMultiselect;

                      if (e.target.className.indexOf('checkbox') > -1 && shouldSelect) {

                        if (e.target.className.indexOf('checked') > -1) {
                          itemSelected = true;
                          element.addClass(selectedClass + ' ' + lastSelected);
                        } else {
                          element.removeClass(selectedClass + ' ' + lastSelected);
                        }
                      } else {

                        if (!angular.element(e.target).closest('tr').hasClass(selectedClass)) {
                          itemSelected = true;
                          element.parent().children().removeClass(selectedClass + ' ' + lastSelected).find('.checkbox').removeClass('checked')
                          element.addClass(selectedClass + ' ' + lastSelected).find('.checkbox').addClass('checked');
                        }
                        else {
                          element.removeClass(selectedClass + ' ' + lastSelected);
                        }
                      }
                    }

                    element.parent().find('tr.k-state-selected').find('.checkbox').addClass('checked');
                    element.parent().find('tr:not(.k-state-selected)').find('.checkbox').removeClass('checked');

                    $scope.$apply(function () { $scope.updateItems(); });

                    if (itemSelected) {

                      let openDetails = e.target.className === 'file-name';

                      itemSelected = false;
                      $scope.$emit('gridItemSelected', {
                        openDetails: openDetails,
                        id: element.attr('data-uid')
                      });
                    }

                  }).bind('mousedown', function (e) { e.preventDefault(); });
                }

                if ($scope.localOptions.enableContextMenu) {

                  var closeContextMenu = function (contextMenu) {
                    $ngRedux.dispatch(actions.hideContextMenu());
                  }

                  visibleRows.unbind('contextmenu').bind('contextmenu', function (e) {
                    
                    e.preventDefault();
                    var element = angular.element(this);

                    if ($scope.contextMenu) {
                      closeContextMenu($scope.contextMenu);
                    }

                    if ($scope.isFolder(element, $scope.kendo[$scope.gridName]._data) && $rootScope.workingFolder.toLowerCase() !== 'recyclebin') { return true; };

                    if (!element.hasClass('k-state-selected')) {

                      $scope.selectedItems = [];

                      element.parent().children().removeClass(selectedClass + ' ' + lastSelected).find('.checkbox').removeClass('checked')
                      element.addClass(selectedClass + ' ' + lastSelected).find('.checkbox').addClass('checked');

                      element.parent().find('tr.k-state-selected').find('.checkbox').addClass('checked');
                      element.parent().find('tr:not(.k-state-selected)').find('.checkbox').removeClass('checked');

                      $scope.$apply(function () { $scope.updateItems(); });

                    };

                    let coordinates = { x: e.pageX, y: e.pageY }

                    const contextMenuOptions = {
                      
                      menuItems: $scope.menuOptions,
                      coordinates: coordinates,
                    }

                    $ngRedux.dispatch(actions.showContextMenu(contextMenuOptions));

                    // doing this because kendo stops propagation
                    angular.element('.k-button').bind('click', function (e) {
                      closeContextMenu($scope.contextMenu);
                    });

                    angular.element('body').bind('click', function (e) {
                      if (!$scope.localOptions.allowRowSelect) {
                        $('.k-grid tr.k-state-selected').removeClass('k-state-selected last-selected').find('.checkbox').removeClass('checked');
                        $scope.selectedItems = [];
                        $scope.updateItems();
                      }
                      angular.element('body').unbind('click');
                    });
                  });
                } else {
                  visibleRows.bind('contextmenu', function (e) { e.preventDefault(); });
                }

                $scope.kendo.resizeGrid();

                angular.element('.k-grid-content').find('.bold').removeClass('bold').closest('tr').addClass('bold');

                $scope.$emit('gridLoaded');
              }

                if ($scope.localOptions.allowColumnState === true) {

                    $scope.localOptions.columnShow = function(e) {

                      _.find($scope.kendo[$scope.gridName].columns, { 'field': e.column.field }).hidden = false;

                        $scope.$broadcast('hideGrid');
                        $scope.saveState(function() { $scope.$broadcast('reloadGrid') });
                    };

                    $scope.localOptions.columnHide = function(e) {

                      _.find($scope.kendo[$scope.gridName].columns, { 'field': e.column.field }).hidden = true;

                        $scope.$broadcast('hideGrid');
                        $scope.saveState(function() { $scope.$broadcast('reloadGrid') });
                    };

                    $scope.localOptions.columnReorder = function(e) {
                        if (e.column.reorderable === false) {
                            return;
                        }

                        $scope.$broadcast('hideGrid');
                        $scope.kendo[$scope.gridName].columns.splice(e.oldIndex, 1);
                        $scope.kendo[$scope.gridName].columns.splice(e.newIndex, 0, e.column);
                        $scope.saveState(function () { $scope.$broadcast('reloadGrid') });
                    };

                    $scope.localOptions.columnResize = function(e) {
                        if (e.column.resizable === false) {
                            return false;
                        }

                        $scope.saveState();
                    };
                  
                    $scope.localOptions.columnMenuInit = function(e) {
                        var menu = e.container.children().data('kendoMenu');
                        var handler = $.proxy(enableCheckbox, menu);

                        menu.bind("open", handler).bind("select", handler);

                        // Custom menu item for resetting columns
                        if($scope.showColumnReset) {
                            menu = e.container.find('.k-menu').data('kendoMenu');

                            menu.append({ text: 'Reset Columns' });
                            menu.bind('select', function(e) {
                                if ($(e.item).text() === 'Reset Columns') {
                                    $scope.onColumnReset();
                                }
                            });
                        }
                    };

                    $scope.saveState = function(callback) {

                        var columns = _.reject($scope.kendo[$scope.gridName].columns, function(c) { return c.resizable === false || c.hidden === true });

                        var columnObject = { "ParentFolderID": $rootScope.workingFolder };
                        var columnArray = [];
                        var sortColumn = "";
                        var sortDir = "";

                        if ($scope.kendo[$scope.gridName].dataSource._sort && $scope.kendo[$scope.gridName].dataSource._sort.length > 0) {
                            sortColumn = $scope.kendo[$scope.gridName].dataSource._sort[0].field;
                            sortDir = $scope.kendo[$scope.gridName].dataSource._sort[0].dir;
                        } else {
                            sortColumn = "FileName";
                            sortDir = "asc";
                        }

                        var sort = 0;

                            _.forEach(columns, function(column) {
 
                                if(column.field) {
                                  if (column.field === sortColumn) {
                                    switch (sortDir) {
                                      case "asc":
                                        sort = 1;
                                        break;
                                      case "desc":
                                        sort = 2;
                                        break;
                                      default:
                                        sort = 0;
                                        break;
                                    }
                                  } else { sort = 0; }

                                    if (column.width.toString().indexOf('px' > 0)) {
                                        column.width.toString().slice(0, -2)
                                    } else {
                                        column.width.toString()
                                    }

                                    columnArray.push(
                                        {
                                            'ColumnID': column.field,
                                            'DisplayName': column.title,
                                            "Sort": sort,
                                            "Visible": !column.hidden,
                                            "Width": column.width - 40 // need to remove padding before saving
                                        }
                                    );
                                }
                        });

                        columnObject.Columns = columnArray;
                        Columns.saveColumns(columnObject, callback);

                    }
                }

                $scope.$watch(function() { return $location.search() }, function(newLocation, oldLocation) {
                    if (oldLocation.page !== newLocation.page) {
                        if ($scope.kendo.grid) {
                            $scope.kendo.grid.dataSource.page(newLocation.page);
                        }
                    }
                });
            }],
            link: function(scope, element, attributes) {

                var loadGrid = function() {
                    //if (sortData) { scope.kendo.gridData = sortData }
                    var columns = scope.gridColumns();

                    if (columns.promise) {
                        columns.promise.then(function(data) {
                            scope.columns = data;
                            compileGrid();
                        });
                    } else {
                        scope.columns = columns;
                        compileGrid();
                    }
                }

                var compileGrid = function() {
                    var gridScope = scope.$new();

                    scope.gridDataSource.page = scope.getCurrentPage();

                    if (scope.$root.pageSize) {
                        scope.gridDataSource.pageSize = scope.$root.pageSize;
                    }
                    
                    scope.gridDataSource.sort = scope.columns.defaultSort;

                    const noRecords = `<div class="ant-empty ant-empty-normal" style="margin:0;padding: 50px 0">
                                        <div class="ant-empty-image">
                                            <img alt="No Data" src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjQiIGhlaWdodD0iNDEiIHZpZXdCb3g9IjAgMCA2NCA0MSIgIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAxKSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgIDxlbGxpcHNlIGZpbGw9IiNGNUY1RjUiIGN4PSIzMiIgY3k9IjMzIiByeD0iMzIiIHJ5PSI3Ii8+CiAgICA8ZyBmaWxsLXJ1bGU9Im5vbnplcm8iIHN0cm9rZT0iI0Q5RDlEOSI+CiAgICAgIDxwYXRoIGQ9Ik01NSAxMi43Nkw0NC44NTQgMS4yNThDNDQuMzY3LjQ3NCA0My42NTYgMCA0Mi45MDcgMEgyMS4wOTNjLS43NDkgMC0xLjQ2LjQ3NC0xLjk0NyAxLjI1N0w5IDEyLjc2MVYyMmg0NnYtOS4yNHoiLz4KICAgICAgPHBhdGggZD0iTTQxLjYxMyAxNS45MzFjMC0xLjYwNS45OTQtMi45MyAyLjIyNy0yLjkzMUg1NXYxOC4xMzdDNTUgMzMuMjYgNTMuNjggMzUgNTIuMDUgMzVoLTQwLjFDMTAuMzIgMzUgOSAzMy4yNTkgOSAzMS4xMzdWMTNoMTEuMTZjMS4yMzMgMCAyLjIyNyAxLjMyMyAyLjIyNyAyLjkyOHYuMDIyYzAgMS42MDUgMS4wMDUgMi45MDEgMi4yMzcgMi45MDFoMTQuNzUyYzEuMjMyIDAgMi4yMzctMS4zMDggMi4yMzctMi45MTN2LS4wMDd6IiBmaWxsPSIjRkFGQUZBIi8+CiAgICA8L2c+CiAgPC9nPgo8L3N2Zz4K">
                                        </div>
                                        <p class="ant-empty-description">No Records Found</p></div>`

                  scope.localOptions.noRecords = { template: noRecords };

                    var gridElement = angular.element(`
                        <div kendo-grid="kendo.{{gridName}}"
                             k-data-source="gridDataSource"
                             k-columns="columns"
                             k-options="localOptions"
                             style="display:none;border:none">
                        </div>`);

                    _.forOwn(scope.flowOptions, function(value, key) {
                        gridElement.attr(key, value);
                    })

                    var el = $compile(gridElement)(gridScope);

                    element.html(el);

                    if (scope.localOptions.responsive) { scope.kendo.resizeGrid(); }

                    $timeout(function () {
                        if (scope.kendo[scope.gridName] && scope.kendo[scope.gridName].pager) {
                          scope.kendo[scope.gridName].pager.bind('change', function (e) {

                                if (scope.localOptions.mainGrid === true) {
                                    $location.search('page', scope.kendo[scope.gridName].dataSource.page());
                                    scope.$apply();
                                }
                            });
                        }
                    })

                    element.children().fadeIn('fast');
                }

                if (scope.localOptions.responsive) {
                    angular.element(window).resize(function () {
                        scope.kendo.resizeGrid();
                    })
                }

                scope.kendo.resizeGrid = function () {

                  var topHeight = 50; // height of header
                  var breadCrumbHeight = 51; // height of breadcrumb
                  var centerHeight = $window.innerHeight - topHeight;
                  centerHeight -= breadCrumbHeight;

                  element.closest('.main-content').siblings().not('#overlay').each((i, element) => centerHeight -= $(element).outerHeight())
                  element.find('.k-grid-content').siblings().each((i, element) => centerHeight -= $(element).outerHeight())

                  element.find('.k-grid-content').css('height', centerHeight);
                }

                if (scope.localOptions.loadOnInit) {
                    loadGrid();
                    if (scope.localOptions.responsive) { scope.kendo.resizeGrid(); }
                }

                scope.$on('hideGrid', function(e) {
                    element.children().hide();
                });

                scope.$on('reloadGrid', function() {
                    if (scope.kendo[scope.gridName]) {
                        if (scope.kendo[scope.gridName].dataSource.view().length === 0
                          && scope.getCurrentPage() !== 1
                          && scope.localOptions.mainGrid === true) {
                            const currentPage = scope.getCurrentPage();
                            const newPage = currentPage > 1 ? currentPage - 1 : 1;
                            console.log(newPage);
                            $location.search('page', newPage);
                        }
                    }

                    element.children().hide();

                    scope.clearSelectedItems();
                    angular.element('.k-reorder-cue').remove();

                    if (element.children().scope()) {
                        element.children().scope().$destroy();
                    }

                    loadGrid();
                });

                scope.$on('markRead', function(e, kendoId) {

                    // if (kendoId !== 'markRead') {

                    //     var itemIndex = _.findIndex(scope.kendo[scope.gridName]._data, { 'uid': kendoId });

                    //     if (itemIndex > -1) {
                    //         scope.kendo[scope.gridName]._data[itemIndex].MessageRead = "1";
                    //     }

                    //     Columns.markRead([_.last(scope.selectedItems).ID]);
                    //     element.find('tr[data-uid="' + kendoId + '"]').removeClass('bold');

                    // } else {

                        Columns.markRead(_.map(scope.selectedItems, 'ID'));
                        _.each(scope.selectedItems, function(item) {

                            var itemIndex = _.findIndex(scope.kendo[scope.gridName]._data, { 'ID': item.ID });

                            if (itemIndex > -1) {
                                scope.kendo[scope.gridName]._data[itemIndex].MessageRead = "1";
                                scope.$emit('selectedItemsUpdated', scope.selectedItems);
                            }
                        });
                        
                        element.find('.k-state-selected').removeClass('bold');
                    // }
                });

                scope.$on('markUnread', function(e) {

                    Columns.markUnread(_.map(scope.selectedItems, 'ID'));

                    _.each(scope.selectedItems, function(item) {

                        var itemIndex = _.findIndex(scope.kendo[scope.gridName]._data, { 'ID': item.ID });

                        if (itemIndex > -1) {
                            scope.kendo[scope.gridName]._data[itemIndex].MessageRead = "0";
                            scope.$emit('selectedItemsUpdated', scope.selectedItems);
                        }
                    });

                    element.find('.k-state-selected').addClass('bold');
                });

                scope.visibleRows = function() { return element.find('tr'); }

                scope.checkAll = function() {
                    scope.visibleRows().find('.checkbox').addClass('checked').closest('tr').addClass('k-state-selected');
                    scope.updateItems();
                };

                scope.uncheckAll = function() {
                    scope.visibleRows().removeClass('k-state-selected').find('.checkbox').removeClass('checked').removeClass('last-selected');
                    scope.updateItems();
                };

                scope.allSelected = function() {
                    if (scope.visibleRows().find('.checkbox').length > 0) {
                        return scope.visibleRows().find('.checkbox:not(.checked)').length === 0;
                    }
                }

                scope.updateItems = function() {
                  scope.removeSelectedItems(element.find('.k-grid-content').find('tr:not(.k-state-selected)'), scope.kendo[scope.gridName]._data);
                  scope.addSelectedItems(element.find('.k-grid-content').find('tr.k-state-selected'), scope.kendo[scope.gridName]._data);
                  
                  scope.$emit('selectedItemsUpdated', scope.selectedItems);
                }

                scope.selectedItems = [];

                scope.clearSelectedItems = function() {
                    scope.selectedItems.length = 0;
                    scope.$emit('selectedItemsUpdated', scope.selectedItems);
                }

              scope.addSelectedItems = function (gridRowCollection, gridData) {
                    if (gridRowCollection.length > 0) {

                        var objectIdArray = _.map(scope.selectedItems, 'ID');;

                        gridRowCollection.each(function() {

                            var uid = angular.element(this).attr('data-uid');
                            var wtObject = _.find(gridData, function(ds) { return ds.uid === uid; });

                          if (!_.includes(objectIdArray, wtObject.ID)) {
                            
                              scope.selectedItems.push(
                                  {
                                      ID: wtObject.ID,
                                      Version: wtObject.VersionID,
                                      VersionID: wtObject.VersionID,
                                      Minor: wtObject.Minor,
                                      Name: wtObject.FileName,
                                      Type: wtObject.ObjectType,
                                      Status: wtObject.Status,
                                      StatusFlags: wtObject.StatusFlags,
                                      Activity: wtObject.Activity,
                                      CheckedOutBy: wtObject.CheckedOutBy,
                                      ProfileID: wtObject.ProfileID,
                                      MessageRead: wtObject.MessageRead
                                  })
                            }
                        });
                    }
                }

              scope.removeSelectedItems = function (gridRowCollection, gridData) {

                    if (gridRowCollection.length > 0) {
                        var objectIdArray = [];

                        var uid;
                        var wtObject;

                        gridRowCollection.each(function() {
                            uid = angular.element(this).attr('data-uid');
                            wtObject = _.find(gridData, function(ds) { return ds.uid === uid; });

                           wtObject && objectIdArray.push(wtObject.ID);
                        });

                        scope.selectedItems = _.reject(scope.selectedItems, function(o) { return _.includes(objectIdArray, o.ID); });
                    }
                }

              scope.isFolder = function (gridRow) {
                  
                  var uid = angular.element(gridRow).attr('data-uid');
                  var row = _.find(scope.kendo[scope.gridName]._data, function (ds) { return ds.uid === uid; });

                if (row) {
                  if ((row.ObjectType && row.ObjectType === 'fod') || row.Folder === '0') {
                    return true;
                  } else {
                    return false;
                  }
                }
                }
            }
        }
    }
])

.directive('wtFolderLink', ['$location', 'GridTools',
    function($location, GridTools) {
        return {
            restrict: 'A',
            replace: false,
            link: function(scope, element, attributes) {
                element.bind('click', function(e) {
                    e.stopPropagation();
                    scope.$emit('gridFolderLinkClicked', element.closest('tr').data('uid'));
                });
            }
        };
    }
])

.directive('wtGridLink', [
    function() {
        return {
            restrict: 'A',
            replace: false,
            link: function(scope, element, attributes) {
                element.bind('click', function(e) {
                    // e.stopPropagation();
                    // scope.$emit('gridItemSelected', { openDetails: true, id: element.closest('tr').data('uid') });
                    // scope.$broadcast('gridItemSelected', { openDetails: true, id: element.closest('tr').data('uid') });
                });
            }
        };
    }
])

.directive('wtViewFileLink', ['GridTools', 'File',
    function (GridTools, Tray, File) {
        return {
            restrict: 'A',
            replace: false,
            link: function (scope, element, attributes) {
                element.bind('click', function (e) {
                    e.stopPropagation();

                    var fileId = element.closest('tr').data('uid');
                    var fileObject = GridTools.getObjectFromGrid(fileId, scope.kendo[scope.gridName]._data);

                    var previewObject = {
							        id: fileObject.ID,
							        version: fileObject.VersionID,
							        minor: fileObject.Minor
                    }

                    scope.$emit('loadObjectPreview', previewObject);
                });
            }
        };
    }
])

.directive('wtProjectLink', [
    function() {
        return {
            restrict: 'A',
            replace: false,
            link: function(scope, element, attributes) {
                element.bind('click', function(e) {
                    e.stopPropagation();
                    scope.$emit('gridProjectLinkClicked', element.closest('tr').data('uid'));
                });
            }
        };
    }
])

.directive('wtSearchLink', [
    function() {
        return {
            restrict: 'A',
            replace: false,
            link: function(scope, element, attributes) {
                element.bind('click', function(e) {
                    e.stopPropagation();
                    scope.$emit('gridSearchLinkClicked', element.closest('tr').data('uid'));
                });
            }
        };
    }
])

.directive('wtStar', ['$rootScope', '$timeout', 'Columns', 'GridTools',
  function ($rootScope, $timeout, Columns, GridTools) {
        return {
            restrict: 'E',
            replace: true,
            transclude: false,
            template: '<icon ng-click="toggleLit($event)" type="\'star\'" fa-style="isSolid" class="star"></icon>',
            link: function(scope, element, attributes) {
                
                scope.isSolid = element.hasClass('star-lit') ? 'fas' : 'fal';

                scope.toggleLit = function(e) {
                    e.stopPropagation();

                    element.toggleClass('star-lit');
                    scope.isSolid = element.hasClass('star-lit') ? 'fas' : 'fal';

                    var dlObject = GridTools.getObjectFromGrid(element.closest('tr').data('uid'), scope.kendo[scope.gridName]._data);

                    if (element.hasClass('star-lit')) {
                        Columns.addFavorite(dlObject);
                    } else {
                        Columns.removeFavorite(dlObject, function() {
                            if ($rootScope.workingFolder.toLowerCase() === 'favorites') {
                              $timeout(() => scope.kendo[scope.gridName].removeRow(element.closest('tr')));
                            }
                        });

                    }
                }
            }
        };
    }
])

.service('GridTools', function() {
    return {
        getObjectFromGrid: function(kendoId, gridData) {
            return _.find(gridData, function(ds) { return ds.uid === kendoId; });
        },
        getObjectsFromGrid: function(kendoIdArray, gridData) {

            var selectedArray = [];

            _.each(kendoIdArray, function(item) {

                var wtObject = _.find(gridData, function(ds) { return ds.ID === item; });

                selectedArray.push(wtObject);
            });

            return selectedArray;
        },
        updateObjectPaths: function(newPath, gridData) {
            _.each(_.filter(gridData, function (o) { return o.ObjectType !== 'fod' }), function (ds) {
                ds.Path = newPath;
            });
        },
    }
})